module.exports = __webpack_public_path__ + "static/media/9@3x.79fe7066.png";